module.exports = __webpack_public_path__ + "static/lavenderbottle-3698cfb1fd253875536c62dbee7da244.png";